module.exports = __webpack_public_path__ + "static/media/Daredevil.91e426e9.jpg";